import { Button, TableCell, TableRow, Typography } from "@mui/material";
import { useContext } from "react";
import useLocales from "src/hooks/useLocales";

import Context from "../../context";

type Props = {
	numberRedirects: number;
};

export default function RowAddRedirect({ numberRedirects }: Props) {
	const { actions } = useContext(Context);
	const { translate } = useLocales();

	return (
		<TableRow>
			<TableCell align={"left"}>
				<Typography variant='body2' color='text.secondary'>
					{numberRedirects !== 0
						? translate("api_client.can_create_redirects")
						: translate("api_client.empty_redirects")}
				</Typography>
			</TableCell>
			<TableCell align={"left"}>
				<Button size='small' variant='outlined' onClick={actions.showCreateRow}>
					{translate("api_client.create_redirect")}
				</Button>
			</TableCell>
			<TableCell align={"left"}>{""}</TableCell>
		</TableRow>
	);
}
